export const DAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export const DAY_LABEL = {
  mon: "Lunes",
  tue: "Martes",
  wed: "Miércoles",
  thu: "Jueves",
  fri: "Viernes",
  sat: "Sábado",
  sun: "Domingo",
};

export const CHANGE_TYPE_LABEL = {
  promotion: "Promoción",
  salary_change: "Cambio salarial",
  schedule_change: "Cambio de horario",
  other: "Otro",
};

export const CHANGE_TYPES = [
  { value: "promotion", label: "Promoción" },
  { value: "salary_change", label: "Cambio salarial" },
  { value: "schedule_change", label: "Cambio de horario" },
  { value: "other", label: "Otro" },
];

const DEFAULT_TIMEZONES = [
  "Europe/Madrid",
  "Europe/Lisbon",
  "Europe/London",
  "Europe/Paris",
  "Europe/Berlin",
  "America/Mexico_City",
  "America/Bogota",
  "America/Argentina/Buenos_Aires",
  "America/Santiago",
  "America/New_York",
  "UTC",
];

export const TIMEZONES = (() => {
  if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
    try {
      const list = Intl.supportedValuesOf("timeZone");
      if (Array.isArray(list) && list.length > 0) {
        return list;
      }
    } catch (_) {
      /* fallback below */
    }
  }
  return DEFAULT_TIMEZONES;
})();

export const formatMinutesShort = (mins) => {
  const m = Number.isFinite(mins) ? Math.max(0, Math.round(mins)) : 0;
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h === 0) return `${r}m`;
  if (r === 0) return `${h}h`;
  return `${h}h ${r}m`;
};

export const formatDate = (d) => {
  if (!d) return "—";
  return d;
};

export const formatMoney = (amount, currency) => {
  if (amount === null || amount === undefined || amount === "") return "—";
  const cur = currency || "EUR";
  const num = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(num)) return `${amount} ${cur}`;
  try {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: cur,
    }).format(num);
  } catch (_) {
    return `${num.toFixed(2)} ${cur}`;
  }
};
